import * as React from 'react';
import { Spinner as UIKitSpinner } from '@cian/ui-kit';

import * as style from './Spinner.css';

interface ISpinnerProps {
  height?: string;
}

export const Spinner: React.FC<ISpinnerProps> = ({ height }) => {
  return (
    <div className={style['spinner']} style={{ height }}>
      <UIKitSpinner size={32} />
    </div>
  );
};
